// pages/barge-logs.tsx
import { useState } from "react";
import { useVoyageContextV2 } from "../../Contexts/VoyageContextV2";
import { Button, Card, CardContent, Typography } from "@mui/material";
import BargeLogModal from "./BargeLogModal";
import { getSelectedTrip } from "../../utils/voyageSelection";

const BargeLogs = () => {
  const { currentVoyage, selectedTripId, isVoyageReadOnly } = useVoyageContextV2();
  const [selectedBargeLog, setSelectedBargeLog] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const trip = getSelectedTrip(currentVoyage, selectedTripId);
  const bargeLogs = trip?.bargeLogs || [];

  const handleOpenModal = (bargeLog = null) => {
    setSelectedBargeLog(bargeLog);
    setModalOpen(true);
  };

  return (
    <div className="p-4">
      <Typography variant="h4">Barge Logs</Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleOpenModal()}
        disabled={isVoyageReadOnly}
        sx={{ marginTop: 2, marginBottom: 2 }}
      >
        Add new Barge Log
      </Button>
      <div className="grid gap-4 mt-4">
        {bargeLogs.map((log) => (
          <Card
            key={log.bargeLogId}
            onClick={() => {
              if (!isVoyageReadOnly) handleOpenModal(log);
            }}
            className="cursor-pointer"
          >
            <CardContent>
              <Typography variant="h6">{log.bargeName}</Typography>
              <Typography variant="body2">
                {log.operationType} - {log.quantity} ton
              </Typography>
              <Typography variant="body2">
                {new Date(log.timestamp).toLocaleString()}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </div>

      <BargeLogModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        bargeLog={selectedBargeLog}
        readOnly={isVoyageReadOnly}
      />
    </div>
  );
};

export default BargeLogs;
